// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProAward2023BannerPromotion_banner__aMKKQ","text-wrapper":"ProAward2023BannerPromotion_text-wrapper__mrHNm","banner-text":"ProAward2023BannerPromotion_banner-text__61rA9"};